import { useSelector } from 'react-redux'
import { getFilter, getIsFetching, getReviews } from 'src/effects/Reviews/selectors'

const MAX_REVIEWS = 3

export function useReviews() {
  const { reviews, reviewsPaginated, pagination } = useSelector(getReviews)
  const isLoading = useSelector(getIsFetching)
  const filter = useSelector(getFilter)

  const hasMoreThanInitial = reviews.length > MAX_REVIEWS

  return {
    reviews: reviews.slice(0, MAX_REVIEWS) ?? [],
    reviewsPaginated: reviewsPaginated ?? [],
    isLoading,
    pagination,
    filter,
    hasMoreThanInitial,
  }
}
